<template>
  <InputGroupAddon align="inline-start">
    <DropdownMenu>
      <DropdownMenuTrigger as-child>
        <InputGroupButton
          type="button"
          size="icon-sm"
          class="tw:rounded-full"
        >
          <i class="tw:i-fal-plus" />
        </InputGroupButton>
      </DropdownMenuTrigger>
      <DropdownMenuContent>
        <DropdownMenuItem
          v-for="func in FUNCTIONS"
          :key="func.label"
          @click="triggerLimitRequests"
        >
          <i :class="func.icon" />
          <span>{{ func.label }}</span>
        </DropdownMenuItem>

        <DropdownMenuItem
          class="tw:text-foreground"
          @click="triggerLimitRequests"
        >
          <i class="tw:i-fal-sparkles" />
          <span>Generate a video</span>
        </DropdownMenuItem>
      </DropdownMenuContent>
    </DropdownMenu>
  </InputGroupAddon>
</template>

<script setup>
import { FUNCTIONS } from '@/components/otto-chat/contants.js'
import { useQuickConversation } from '@/components/quick-conversation/use-quick-conversation.js'
import {
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuItem,
  DropdownMenuTrigger,
} from '@/shadcn/components/ui/dropdown-menu/index.js'
import { InputGroupAddon, InputGroupButton } from '@/shadcn/components/ui/input-group/index.js'

const { triggerLimitRequests } = useQuickConversation()
</script>
